// Shared DOM anchor ids for in-page dashboard navigation (e.g. the next-session
// card's "homework to do" chip scrolling to the coach-homework panel).
export const HOMEWORK_ANCHOR_ID = "dashboard-homework";
